// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VAJR","left":"styles_left__2Bwd_"};